import { ComponentProps, FC } from 'react';

import { getWeekdayTitle } from '@/utils/dateUtils';
import { Axis } from '@visx/axis';

import useMwdTimescale from '../../state/selectors/useMwdTimescale';

import styles from './TimeScale.module.css';

const TickDays: FC<Partial<ComponentProps<typeof Axis>> & { mini?: boolean }> = ({
  mini = false,
  ...overwriteAxisProps
}) => {
  const { scale, tickValuesDays } = useMwdTimescale(mini ? 'miniMwd' : 'mwd');

  return (
    <Axis
      orientation='top'
      scale={scale}
      left={0}
      top={0}
      tickFormat={(v: Date, _: number) => {
        return getWeekdayTitle(v);
      }}
      tickValues={tickValuesDays}
      strokeWidth={0}
      tickClassName={styles.tickDaysStyle}
      {...overwriteAxisProps}
    />
  );
};
export default TickDays;
